module.exports = __webpack_public_path__ + "static/media/locationMap.6d35e6f9.svg";